export const css = {
    root: '_3IL-lZZF',
    input: '_2Jz8gM21',
    inputWrapper: '_1dlq4UlP',
    radioBackground: '_2zes3-Wt',
    radioOuter: '_1xIubGYF',
    radioInner: '_1SWnQZG4',
    focused: '_2XTkWRcz',
    checked: '_36l7N0SL',
    disabled: 'R3LzkY85',
    readonly: '_1cp5uNt_',
    invalid: '-yZCTUnh',
    valid: '_1QF-nnLR',
    ' _key': 'afcpe-theme/dojo/radio'
};
export default css;
